import React from 'react';
import { useSpring, animated } from 'react-spring';
import { SPEED_SLOW } from '@nokia-csf-uxr/freeform-design-tokens/tokens/speed';
import { getDuration } from 'common';

export interface AnimatedTooltipContainerProps {
  children: React.ReactNode;
  animationProps: any
}

const AnimatedTooltipContainer = React.forwardRef<HTMLDivElement, AnimatedTooltipContainerProps>((props: AnimatedTooltipContainerProps, ref) => {
  const {
    children,
    animationProps,
  } = props;
  const styles = useSpring({
    to: { opacity: 1, transform: 'scale(1)', transformOrigin: '0 0' },
    from: { opacity: 0, transform: 'scale(0)', transformOrigin: '0 0' },
    config: {
      duration: getDuration(SPEED_SLOW)
    },
    ...animationProps
  });

  return <animated.div ref={ref} style={styles}>{children}</animated.div>;
});

AnimatedTooltipContainer.displayName = 'AnimatedTooltipContainer';
export default AnimatedTooltipContainer;

